const cat = (name, items) => ({ name, items });
const qa = (q, a) => ({ q, a });

export const faqCategories = [
  cat('Getting Started', [
    qa(
      'How does an engagement actually start?',
      'A short scoping call to understand what you need tested or managed, followed by a written proposal within one business day. For testing engagements, we agree rules of engagement and a test window before anything touches your environment.'
    ),
    qa(
      'How long does a typical penetration test take?',
      'Scoping and rules of engagement take a few days. The testing itself usually runs 3-10 business days depending on scope, and the report follows within a week of testing completion. Larger network or multi-application engagements run longer — we will give you a specific timeline once we know the scope.'
    ),
    qa(
      'Do you offer one-off engagements, or only ongoing contracts?',
      'Both. Penetration testing and compliance work are commonly one-off or annual. Managed IT and SOC monitoring are ongoing by nature. We do not require you to bundle services you do not need.'
    ),
  ]),
  cat('Penetration Testing & Assessments', [
    qa(
      'What is actually included in the report?',
      'Every finding includes a description, proof-of-concept steps, business impact, CVSS-based severity, and specific remediation guidance — not just "patch this." Reports also include an executive summary written for non-technical stakeholders.'
    ),
    qa(
      'Do you retest after we fix the findings?',
      'Yes — a retest is included in our standard VAPT engagements, typically within 30 days of your remediation work, to confirm the fixes actually closed the issue rather than just changed its shape.'
    ),
    qa(
      'Will testing disrupt our production environment?',
      'We scope every engagement to avoid unnecessary disruption and agree a testing window with you in advance. Where production or safety-critical systems are involved, we use a conservative, safety-first approach and avoid tests with a risk of causing outages.'
    ),
    qa(
      'What is the difference between a vulnerability assessment and a penetration test?',
      'A vulnerability assessment identifies and catalogs potential weaknesses, largely through scanning. A penetration test goes further — our testers manually attempt to exploit those weaknesses to prove real-world impact, which is what separates a theoretical finding from an actual risk.'
    ),
  ]),
  cat('Compliance', [
    qa(
      'How long does ISO 27001 certification take from a standing start?',
      'For a well-resourced mid-market organization, three to four months from gap assessment to Stage 2 certification audit is realistic. It depends heavily on how much of the ISMS already exists versus needs to be built from scratch.'
    ),
    qa(
      'Can you help with both ISO 27001 and SOC 2?',
      'Yes, and if you eventually need both, we recommend sequencing them — most of the underlying control work overlaps, so the second framework is meaningfully cheaper once the first is in place.'
    ),
    qa(
      'Do you perform the actual certification audit?',
      'No — certification audits must be performed by an accredited, independent certification body to be valid. We prepare you for that audit: gap assessment, control implementation, and internal audit support, but the certification decision itself sits with the external body.'
    ),
  ]),
  cat('Managed Services', [
    qa(
      'What does "24/7 SOC monitoring" actually mean in practice?',
      'Continuous SIEM monitoring with analyst-led triage — when a detection fires, an analyst reviews it, and confirmed threats get escalated with a coordinated response, not just an automated alert email at 3 a.m.'
    ),
    qa(
      'Can you work alongside our existing internal IT team instead of replacing them?',
      'Yes — this is our co-managed model. We slot into where you have gaps (24/7 coverage, specialized testing, compliance expertise) rather than requiring you to hand over everything.'
    ),
    qa(
      'What is your guaranteed response time?',
      'We respond to every inquiry within one business day. For managed SOC clients, mean time to triage a confirmed alert is under 30 minutes.'
    ),
  ]),
];
